// Header + footer only. Used by standalone templates (template-or-blocks.php)
// that drop the full front-end bundle.
import './global/header';
import './global/footer';
import './global/chat';
import './global/utm-links';
